import { render, staticRenderFns } from "./ReportPageReworked.vue?vue&type=template&id=31b0d99b"
import script from "./ReportPageReworked.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportPageReworked.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports